
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { createTooltip, destroyTooltip } from 'v-tooltip';

const cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;';
const copyErrorText = 'Failed to copy to clipboard.';
const copySuccessText = 'Copied!';

const copyToClipboard = input => {
  const textarea = document.createElement('textarea');
  let value;

  if (typeof input !== 'string') {
    try {
      value = JSON.stringify(input);
    } catch (event) {
      throw copyErrorMessage;
    }
  } else {
    value = input;
  }

  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.cssText = cssText;
  document.body.appendChild(textarea);
  textarea.select();
  let success = false;

  try {
    success = document.execCommand('copy');
  } catch (err) {
    console.warn(err);
  }

  document.body.removeChild(textarea);
  return success;
};

function clickEventHandler(el) {
  if (el.dataset.value) {
    const classes = 'pendo-tooltip has-tooltip-arrow';
    const tooltip = createTooltip(el, {
      content: null,
      trigger: 'manual',
      classes,
      offset: 8
    }, {});

    if (copyToClipboard(el.dataset.value)) {
      tooltip.setContent(copySuccessText);
    } else {
      tooltip.setContent(copyErrorText);
    }

    tooltip.show();
    el.addEventListener('mouseleave', function _mouseleave() {
      tooltip.hide();
      destroyTooltip(el);
      el.removeEventListener('mouseleave', _mouseleave);
    });
  }
}

function bind(el, {
  value
}) {
  el.dataset.value = value;
  el.setAttribute('title', 'Copy to Clipboard');
  el.addEventListener('click', clickEventHandler.bind(null, el));
  return;
}
function update(el, {
  oldValue,
  value
}) {
  if (value !== oldValue) {
    el.dataset.value = value;
  }
}
function unbind(el) {
  el.removeEventListener('click', clickEventHandler);
}
const PendoClipboard = {
  bind,
  update,
  unbind
};

export default PendoClipboard;
export { PendoClipboard, bind, unbind, update };
